import { Component, input, output } from '@angular/core';
import { SettingsSideNavItem } from '../settings-side-nav/settings-side-nav.types';

@Component({
  selector: 'app-settings-side-nav-section',
  standalone: false,
  templateUrl: './settings-side-nav-section.component.html',
  styleUrl: './settings-side-nav-section.component.scss'
})
export class SettingsSideNavSectionComponent {
  /**
   * The section title to display in uppercase
   */
  title = input.required<string>();

  /**
   * The navigation items to display in this section
   */
  items = input.required<SettingsSideNavItem[]>();

  /**
   * The currently selected item ID
   */
  selectedItemId = input<string>('');

  /**
   * Emits when a navigation item is clicked
   */
  itemClicked = output<SettingsSideNavItem>();

  /**
   * Checks if an item is currently selected
   */
  isSelected(itemId: string): boolean {
    return this.selectedItemId() === itemId;
  }

  /**
   * Handles navigation item click
   */
  onItemClick(item: SettingsSideNavItem): void {
    this.itemClicked.emit(item);
  }
}
